import { useQuery } from '@tanstack/react-query';
import { chatMembersRead } from '@zealot/shared/apiClient';
import type { Client } from '@zealot/shared/apiClient/client';

type ChatMember = {
  uuid: string | null;
  forumUserUuid: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  picture: string | null;
  jobTitle: string | null;
  company: string | null;
  role: 'admin' | 'member';
};

type ChatMembersResponse = {
  admins: ChatMember[];
  members: {
    data: ChatMember[];
    pagination: {
      total: number;
      page: number;
      pageSize: number;
    };
  };
};

type UseChatMembersOptions = {
  search?: string;
  page?: number;
  pageSize?: number;
  enabled?: boolean;
};

export const useChatMembers = (client: Client, options: UseChatMembersOptions = {}) => {
  const { search, page = 1, pageSize = 20, enabled = true } = options;

  return useQuery<ChatMembersResponse>({
    queryKey: ['chatMembers', { search, page, pageSize }],
    queryFn: async () => {
      const response = await chatMembersRead({
        client,
        query: { search, page, pageSize },
      });
      return response?.data?.data as ChatMembersResponse;
    },
    enabled,
  });
};
